import { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import Button from "../../components/Button";
import { getStats } from "../../crud/dashboard.crud";
import styles from "../../styles/Dashboard.module.scss";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import UserGroup from "../../components/icons/UserGroup";
import { CircularProgress } from "@material-ui/core";

const STATUS_LABELS = {
    SOLICITADA: { label: "Solicitada", classe: styles.badgeSolicitada },
    ACEITA: { label: "Aceita", classe: styles.badgeAgendada },
    EM_ANDAMENTO: { label: "Em andamento", classe: styles.badgeEmAndamento },
    FINALIZADA: { label: "Finalizada", classe: styles.badgeFinalizada },
    CANCELADA_PASSAGEIRO: { label: "Cancelada", classe: styles.badgeCancelada },
    CANCELADA_MOTORISTA: { label: "Cancelada", classe: styles.badgeCancelada },
    CANCELADA_SISTEMA: { label: "Cancelada", classe: styles.badgeCancelada },
};

class DashboardPage extends Component {
    state = {
        total_colaboradores: null,
        viagens_em_andamento: null,
        viagens_realizadas_mes: null,
        ultimas_viagens: null,
    };

    componentDidMount() {
        getStats()
            .then((res) => {
                this.setState({
                    total_colaboradores: res.data.total_colaboradores,
                    viagens_em_andamento: res.data.viagens_em_andamento,
                    viagens_realizadas_mes: res.data.viagens_realizadas_mes,
                    ultimas_viagens: res.data.ultimas_viagens,
                });
            })
            .catch(() => {
                this.setState({
                    total_colaboradores: 0,
                    viagens_em_andamento: 0,
                    viagens_realizadas_mes: 0,
                    ultimas_viagens: [],
                });
            });
    }

    formatarDataAgendamento = (data_iso) => {
        if (!data_iso) {
            return "";
        }

        const data = new Date(data_iso);
        const dia = data.getDate();
        const meses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
        const mes = meses[data.getMonth()];
        const horas = String(data.getHours()).padStart(2, "0");
        const minutos = String(data.getMinutes()).padStart(2, "0");

        return `${dia} de ${mes}, ${horas}:${minutos}`;
    };

    render() {
        const {
            total_colaboradores,
            viagens_em_andamento,
            viagens_realizadas_mes,
            ultimas_viagens,
        } = this.state;

        return (
            <div className={styles.container}>
                <p className={styles.tituloPagina}>Início</p>

                <div className={styles.statsGrid}>
                    <div className={styles.statCard}>
                        <span className={styles.statIcone}>
                            <UserGroup />
                        </span>
                        <div className={styles.statTextBlock}>
                            <p className={styles.statLabel}>Colaboradores cadastrados</p>
                            {total_colaboradores === null
                                ? <CircularProgress size={24} color="inherit" />
                                : <p className={styles.statValor}>{total_colaboradores}</p>
                            }
                        </div>
                    </div>

                    <div className={styles.statCard}>
                        <span className={`${styles.statIcone} material-symbols-outlined`} style={{ display: "flex", justifyContent: "center", alignItems: "center", fontVariationSettings: "'FILL' 1" }}>minor_crash</span>
                        <div className={styles.statTextBlock}>
                            <p className={styles.statLabel}>Viagens em andamento</p>
                            {viagens_em_andamento === null
                                ? <CircularProgress size={24} color="inherit" />
                                : <p className={styles.statValor}>{viagens_em_andamento}</p>
                            }
                        </div>
                    </div>

                    <div className={styles.statCard}>
                        <span className={`${styles.statIcone} material-symbols-outlined`} style={{ display: "flex", justifyContent: "center", alignItems: "center", fontVariationSettings: "'FILL' 1" }}>ambulance</span>
                        <div className={styles.statTextBlock}>
                            <p className={styles.statLabel}>Viagens realizadas este mês</p>
                            {viagens_realizadas_mes === null
                                ? <CircularProgress size={24} color="inherit" />
                                : <p className={styles.statValor}>{viagens_realizadas_mes}</p>
                            }
                        </div>
                    </div>

                    <div className={styles.statCardCta}>
                        <h5>Organize suas viagens corporativas com agilidade.</h5>

                        <Button
                            type="button"
                            variant="primary"
                            size="md"
                            fullWidth
                            onClick={() => this.props.history.push("/viagens/novo")}
                        >
                            Solicitar Chof&nbsp;&nbsp;<span class="material-symbols-outlined" style={{ fontSize: "20px" }}>arrow_forward</span>
                        </Button>
                    </div>
                </div>

                <div className={styles.secao}>
                    <div className={styles.secaoHeader}>
                        <p className={styles.secaoTitulo}>Viagens</p>
                        <Link to="/viagens" className={styles.linkVerTodas}>Ver todas</Link>
                    </div>

                    {ultimas_viagens === null && (
                        <div className="d-flex justify-center">
                            <BetterCircularProgress loading={ultimas_viagens === null} />
                        </div>
                    )}

                    <div className={styles.viagensGrid}>
                        {ultimas_viagens !== null && ultimas_viagens.length === 0 && (
                            <p style={{ color: "var(--gray-7)", fontSize: "14px" }}>Nenhuma viagem encontrada.</p>
                        )}

                        {ultimas_viagens !== null && ultimas_viagens.map((viagem) => {
                            const status_info = STATUS_LABELS[viagem.status] || { label: viagem.status, classe: styles.badgeSolicitada };

                            return (
                                <div key={viagem.id} className={styles.viagemCard} style={{ cursor: "pointer" }} onClick={() => this.props.history.push(`/viagens/${viagem.id}`)}>
                                    <div className={styles.viagemCardHeader}>
                                        <div>
                                            <p className={styles.viagemPassageiro}>{viagem.passageiro}</p>
                                            <p className={styles.viagemDataHora}>{this.formatarDataAgendamento(viagem.data_agendamento)}</p>
                                        </div>
                                        <span className={`${styles.badge} ${status_info.classe}`}>
                                            {status_info.label}
                                        </span>
                                    </div>

                                    <div className={styles.viagemDetalhes}>
                                        <div>
                                            <p className={styles.viagemDetalheLabel}>Motorista</p>
                                            <p className={styles.viagemDetalheValor}>{viagem.motorista}</p>
                                        </div>
                                        <div>
                                            <p className={styles.viagemDetalheLabel}>Veículo</p>
                                            <p className={styles.viagemDetalheValor}>{viagem.veiculo}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(DashboardPage);
